import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const Hero = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // อนิเมชั่นตัวหนังสือค่อยๆ เด้งขึ้นมา
      gsap.from(".hero-text", {
        y: 100,
        opacity: 0,
        duration: 1.2,
        stagger: 0.2,
        ease: "power4.out",
        delay: 0.8
      });
    }, heroRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={heroRef} className="relative min-h-screen bg-[#0f172a] flex items-center justify-center overflow-hidden px-6">
      
      {/* Background Ambient Glow (ตัวแก้เลี่ยน) */}
      <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-blue-600/10 blur-[120px] rounded-full"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-yellow-500/5 blur-[120px] rounded-full"></div>

      <div className="relative z-10 text-center">
        {/* ตำแหน่ง: เล็กแต่คม */}
        <div className="hero-text overflow-hidden mb-4">
          <span className="inline-block text-yellow-500 font-black tracking-[0.4em] uppercase text-[10px] md:text-xs italic">
             Fullstack Developer
          </span>
        </div>

        {/* ชื่อ/Headline: ใหญ่และดุดัน */}
        <div className="hero-text overflow-hidden">
          <h1 className="text-7xl md:text-[10rem] font-black text-white leading-[0.8] tracking-tighter uppercase italic">
            Justin <br />
            <span className="text-transparent font-outline-2">PORT</span>
            <span className="text-yellow-500">FOLIO.</span>
          </h1>
        </div>

        {/* Description: เนียนตา */}
        <div className="hero-text overflow-hidden mt-8">
          {/* <p className="text-slate-400 max-w-xl mx-auto text-base md:text-lg font-medium leading-relaxed">
            Crafting high-throughput automation and scalable interaction layers <br className="hidden md:block" /> 
            for the next generation of on-chain ecosystems.
          </p> */}
          <p className="text-slate-400 max-w-2xl mx-auto text-base md:text-lg font-medium leading-relaxed mb-14">
            Building Full Stack solutions for the decentralized future from <br className="hidden md:block" />
            High-End Web Apps to Autonomous Crypto Infrastructure.
          </p>
        </div>

        {/* CTA Button: รับกับ Navbar */}
        <div className="hero-text overflow-hidden mt-12">
          <a href="#about">
          <button className="group relative bg-white text-slate-900 px-10 py-4 rounded-full font-black uppercase text-sm transition-all hover:bg-yellow-500 active:scale-95 shadow-2xl">
            Explore My Works
            <span className="absolute inset-0 rounded-full bg-white blur-lg opacity-0 group-hover:opacity-20 transition-opacity"></span>
          </button>
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-30">
        <span className="text-[10px] font-bold text-white uppercase tracking-widest italic">Scroll</span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-white to-transparent"></div>
      </div>
    </section>
  );
};

export default Hero;